import { Component, Input } from '@angular/core'


@Component({
  selector: '[app-select-menu-list-named-section-item]',
  template: `
       <span class="name">{{name}}</span>
    `,
  styles: '',
})
export class SelectMenuListNamedSectionComponent{
  @Input({ required: true }) name: string
}